export default "__VITE_ASSET__BCKq$R6K__"